import Model from "./Model";

export default class Media extends Model {
  static type = "media";
  static radio = "1";
  static tv = "2";

  static mediaToList({ radio, tv }: { radio: boolean; tv: boolean }) {
    const media = [];
    if (radio) {
      media.push(Media.radio);
    }
    if (tv) {
      media.push(Media.tv);
    }
    return media;
  }

  get isRadio(): boolean {
    return this.id == Media.radio;
  }

  get isTV(): boolean {
    return this.id == Media.tv;
  }
}

export const MEDIA_LABELS: Record<string, string> = {
  [Media.radio]: "Radio",
  [Media.tv]: "Tv",
};
